/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import type { ForcBaseArgs } from "parog-web/components/forc/abstract/base-component";
import JournalEventBasedComponent from "parog-web/components/forc/abstract/journal-event-based-component";
import JournalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import FeelingEvasDeclaredJournalEvent from "parog-web/models/feeling-evas-declared-journal-event";
import type SurveyRequestedJournalEvent from "parog-web/models/survey-requested-journal-event";

interface Args extends ForcBaseArgs {
  surveyRequested: SurveyRequestedJournalEvent;
}

export default class FeelingEvasFormComponent extends JournalEventBasedComponent<Args> {
  static forcDisplayName = "Ressenti patient";
  static fullComponentId = "feeling-evas/form";

  static journalEventClass = FeelingEvasDeclaredJournalEvent;

  journalEventProperties = [
    "occurredAt",
    "mood",
    "energy",
    "irritability",
    "sleepDuration",
    "anxiety",
    "comments"
  ];

  sliderStyles = "mt-[1.5em]";
  retrieveJournalEvent = JournalEventRetrievalStrategies.sourceJournalEvent;

  @action
  labels(labels: Record<string, unknown>, value: string) {
    if (!labels[value]) return "";

    // HACK: using "&nbsp;" here to fix a positionning bug
    return "&nbsp;" + labels[value];
  }

  get defaultModel() {
    return {
      mood: 0,
      energy: 0,
      irritability: 0,
      sleepDuration: 0,
      anxiety: 0
    };
  }

  async save() {
    this.changeset.set("occurredAt", new Date());
    const journalEvent = await super.save();

    if (this.args.surveyRequested) {
      const surveyCompleted = this.store.createRecord(
        "survey-completed-journal-event",
        {
          patient: this.patient,
          occurredAt: new Date(),
          rawInputs: this.model,
          linkedJournalEventIds: [journalEvent.id],
          formId: "feeling-evas/form",
          surveyRequestedJournalEvent: this.args.surveyRequested
        }
      );

      await surveyCompleted.save();
    }
  }

  @action
  setProperty(propertyName: string, value: number) {
    const precision = 10;
    const roundedValue = Math.round(value * precision) / precision;

    if (roundedValue != value) {
      console.warn(
        "FUI slider.js rounding bug happened. We had to re-round the value. See https://github.com/fomantic/Fomantic-UI/issues/1545"
      );
    }

    if (this.changeset.get(propertyName) === roundedValue) return;

    this.changeset.set(propertyName, roundedValue);
  }
}
